module.exports = __webpack_public_path__ + "media/images/lr-lenscap-5a9eb7b3.svg";